import React, { lazy, Suspense, useEffect } from 'react';
import {useDispatch} from 'react-redux';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import {compose} from 'redux';
import {useTranslation, withTranslation} from 'react-i18next';
import {hot} from 'react-hot-loader/root';
import {Button, ThemeProvider} from '@workboard/wobo-ui';
import UserServices from '../../../services/user.services';
import * as leftmenuActions from '../../actions/leftmenu.actions';
import BoardConst from '../../../constants/shared_board.constants';
import RbrConst from '../../../constants/rbr.constants';
import NotesOutlinedIcon from '@mui/icons-material/NotesOutlined';


const CreateCopyKrModal = lazy(() => import(
  /* webpackChunkName: "copy-kr-modal" */
  '../../../components/okr/modals/copy-kr-modal'
));

const CreateBoardPopup = lazy(() => import(
  /* webpackChunkName: "create.board" */
  '../../../board/modals/create.board'
));
const JumpToSearchComp = lazy(() => import(
  /* webpackChunkName: "jumptosearch" */
  './jumptosearch'
));
const CreateMeetingModalStandalone = lazy(() => import(
    /* webpackChunkName: "create-meeting-standalone" */
    '../../../apps/meetings/modals/create-meeting-standalone'
));
const Create1on1ModalStandalone = lazy(() => import(
    /* webpackChunkName: "create-1on1-standalone" */
    '../../../apps/meetings/modals/create-1on1-standalone'
));

const leftMenuWidth = { closed: 40, open: 275 };
const userService = new UserServices();

const LeftMenuComp = (props) => {
  const dispatch = useDispatch();
  const { t, permissions = {}, enableModules = {},
    id = 'menu', title = '', actions, menus = [],
    menu_sorting = false, sorting = {}, keep_open = false,
    show_collapse_all = true, collapse_all = 0, links = []
  } = props;
  const menuId = id;
  useEffect(() => {
    if (menuId == 'board' || menuId == 'team') {
      resizeHeaderSction();
    }
    setTimeout(() => leftMenuScrollHeight(menuId), 0);
  }, [menuId]);

  useEffect(() => {
    if(keep_open == "false" && document.getElementById('globalLeftKeepOpen')){
      document.getElementById('globalLeftKeepOpen').focus();
    }
    else if(document.getElementById('globalCloseLeft')) {
      document.getElementById('globalCloseLeft').focus();
    }
  }, [keep_open]);

  useEffect (() => {
    if(props.id == 'board'){
      const onlyTeamWs = props.menus.filter(dt => (typeof dt.id == 'number' && Math.sign(dt.id) > 0));
      if(onlyTeamWs.length > 0 && onlyTeamWs.length < 20){
        const params = {
          menuId: props.id,
          offset: onlyTeamWs.length
        };
        dispatch(leftmenuActions.updateLeftMenu(params));
      }
    }
  }, [id, props.menus?.length]);

  const getButtons = () => {
    const _buttons = [];
    const executeModule = wbConfig.enableModules.execute || 0;
    if (menuId == 'rbr') {
      _buttons.push({
        id: 'rbr_add_rbr',
        title: 'Add Biz Review',
        iconPath: '/images/icons/main_menu/add/biz review grey@3x.png',
        class: 'rbr_add_rbr',
        uniqClass: 'leftMenuMargin',
        attributes: { 'role': 'button', 'tabIndex': '0'}
      });
    } else if (menuId == 'board') {
      if (executeModule == '1') {
        _buttons.push({
          id: 'addWorkstrem',
          title: 'Add workstream',
          iconPath: '/images/icons/main_menu/add/ws.png',
          class: 'addWorkstream',
          uniqClass: 'leftMenuMargin',
          attributes: { 'role': 'button', 'tabIndex': '0'}
        });
      }
      // if(enableModules.boardModule == "1"){
      _buttons.push({
        id: 'board_add_board',
        title: 'Add visual board',
        iconPath: '/images/icons/main_menu/add/board grey@3x.png',
        class: 'board_add_board',
        uniqClass: 'leftMenuMargin',
        attributes: { 'data-board-module' : enableModules.boardModule, 'role': 'button', 'tabIndex': '0'}
      });
      // }
    } else if (menuId == 'team') {
      _buttons.push({
        id: 'add-working-group',
        title: 'Add team',
        iconPath: '/images/icons/main_menu/add/team grey@3x.png',
        class: 'add-working-group',
        uniqClass: 'leftTeamMenuMargin',
        attributes: { 'role': 'button', 'tabIndex': '0'}
      });
    } else if (menuId == 'mywork') {
      _buttons.push({
        id: 'add-ai',
        title: 'Add action item',
        iconPath: '/images/icons/main_menu/add/aciton item grey@3x.png',
        class: 'add-ai add-ai-position',
        uniqClass: 'leftMenuMargin',
        attributes: { 'role': 'button', 'tabIndex': '0'}
      });
      _buttons.push({
        id: 'add-email-report',
        title: 'Email Report',
        iconPath: '/images/icons/main_menu/add/email.png',
        class: 'add-email-report',
        uniqClass: 'leftMenuMargin',
        attributes: { 'role': 'button', 'tabIndex': '0'}
      });
    } else if (menuId == 'meeting') {
      if (
        permissions.isMyManagerSubscriped ||
        permissions.currentUserSubscription
      ) {
        _buttons.push({
          id: 'add-meetingnow',
          title: 'Meet Now',
          iconPath: '/images/icons/main_menu/add/meet now blue.png',
          class: 'add-group-meeting',
          attributes: { 'data-tid': 0, 'role': 'button', 'tabIndex': '0'},
          buttonAttrs: { "data-testid": "left-nav-meet-now" },
          uniqClass: 'leftMenuMargin leftMenuMeetNow',
        });
        _buttons.push({
          id: 'add-newmeeting',
          title: 'New Meeting',
          iconPath: '/images/icons/main_menu/add/meeting.png',
          class: 'add-meeting add-meeting-postion',
          attributes: { 'data-tid': 0, 'role': 'button', 'tabIndex': '0'},
          uniqClass: 'leftMenuMargin',
        });
        _buttons.push({
          id: 'add-1on1',
          title: 'New 1on1',
          iconPath: '/images/icons/main_menu/add/meeting.png',
          class: 'add-1on1 add-10n1 add-meeting-postion add-oneOnone',
          uniqClass: 'leftMenuMargin leftMenuOneOnOne',
          attributes: { 'role': 'button', 'tabIndex': '0'}
        });
      }
    } else if (menuId == 'goal') {
      if (
        (permissions.currentUserSubscription ||
          permissions.isMyManagerSubscriped) &&
        permissions.isDisableFeature
      ) {
        _buttons.push({
          id: 'add-personal-objective',
          title: `${t('Add personal objective')}`,
          iconPath:
            '/images/icons/main_menu/add/personal objective grey@3x.png',
          class: 'goalSetIndividualGoal',
          attributes: { 'data-mygoal': 1, 'role': 'button', 'tabIndex': '0','data-testid':'add_personal_objective'},
          uniqClass: 'leftMenuGoalMargin',
        });
      }
      if ((permissions.currentUserSubscription || permissions.isMyManagerSubscriped) && permissions.teamManagerCount) {
        _buttons.push({
          id: 'add-team-objective',
          title: `${t('Add team objective')}`,
          iconPath: '/images/icons/main_menu/add/team grey@3x.png',
          class: 'goalSetTeamGoal',
          uniqClass: 'leftMenuGoalMargin',
          attributes: { 'role': 'button', 'tabIndex': '0','data-testid':'add_team_objective'}
        });
      }
    }
    return _buttons;
    // console.log('buttons', buttons);
    // this.props.buttons = [new Set(_buttons)];
  }

  const openCloseAllExpand = (e, status) => {
    actions.UpdateCollapseMenu(id, status);
    const params = {
      type: id,
      status,
      ids: menus.map(m => m.id)
    };
    userService.openCloseAllTray(params);
  }

  const clickKeepOpen = (e, open) => {
    e.preventDefault();
    actions.UpdateKeepOpenStatus(open);
    if(typeof window.OrgResultsComp != 'undefined' && window.OrgResultsComp != null){
      window.OrgResultsComp.onsidebarClick(open);
    }
    if (open == 'true') {
      if (menuId == 'rbr') {
        resizeRbrSction(true, open);
      }
      if (menuId == 'goal') {
        resizeHeatmapCharts();
      }
      if ($('.kr-det-graph-div').length) {
        resizeKrDetailsGraph();
      }
    } else {
      if (menuId == 'rbr') {
        resizeRbrSction(true, open);
      }
      if (menuId == 'goal') {
        resizeHeatmapCharts();
      }
      if($('.alignmentTreeHeader').length) {
        $('.alignmentTreeHeader').width(screen.width - (screen.width/8.32));
      }
      if($('.treeData').length) {
        $('.treeData').width(screen.width - (screen.width/8.32));
      }
      if ($('.kr-det-graph-div').length) {
        resizeKrDetailsGraph();
      }
    }

    if ($('.ie').length) {
      let elem = $('.ie');
      const isOpen = (open == 'true');
      for(let i = 0; i < elem.length;i++) {
        elem.removeClass((isOpen ? 'leftmenu-closed' : 'leftmenu-open'));
        elem.addClass((isOpen ? 'leftmenu-open': 'leftmenu-closed'));
      }
    }

    setTimeout(() => {
      leftMenuScrollHeight(menuId);
      if (menuId == 'board' || menuId == 'team') {
        resizeHeaderSction();
      }
    }, 10);
    userService.saveUserPreferenceWs({
      keepOpen: open
    });
  }

  const clickCollapse = (e, _menuId, status) => {
    e.preventDefault();
    const collaspe = status ? 0 : 1;
    actions.UpdateCollapseSingleMenu(id, _menuId, !status);
    const params = {
      type: _menuId,
      pageType: id,
      status: collaspe,
      openCloseAllTray: ''
    };
    userService.saveMyWorkCollapse(params);
  }

  const buttons = getButtons();
  const width = keep_open == 'true' ? leftMenuWidth.open : leftMenuWidth.closed;
  setLeftMenuWidth(width);
  cssUpdates(width);
  const leftmenuStyles = {};
  let menuSortingId = '';
  if (id == 'board') {
    menuSortingId = 'streams';
  }
  const leftMenuWidthClass =
  keep_open == 'true' ? 'width275' : 'width40';
  return (
    <div
      className={`leftmenu-wrapper ${leftMenuWidthClass}`}
      data-menu-id={id}
      data-keepopen={keep_open}
      style={leftmenuStyles}
      role="navigation"
      aria-describedby="menu-bar-title"
    >
      {keep_open == 'true' ? (
        <div className={`leftmenu-content ${id}-menu-content`}>
          <div className="leftmenu-menu-head">
            <div role="heading" aria-level="2"
              className={`${id}-menu-bar wbInlineBlock menu-title-left`}
              id="menu-bar-title"
            >
              {title}
            </div>
            <div
              className={`${id}-menu-right wbInlineBlock `}
              style={{display: "inline-block"}}
            >
              <ThemeProvider>
                <Button
                  aria-expanded="true"
                  aria-label="toggle-sidebar"
                  className="clickable globalCloseLeft"
                  id="globalCloseLeft"
                  style={{ display: 'inline-block', padding: 0, height: 24, minWidth: 54 }}
                  onClick={e => clickKeepOpen(e, 'false')}>
                  <img
                    // aria-hidden="true"
                    src={`${wbConfig.baseUrl}/images/icons/main_menu/add/ic-hide.png`}
                    title="Hide side panel"
                    width="24px"
                  />
                </Button>
              </ThemeProvider>
            </div>
            <Suspense fallback={null}>
              <JumpToSearchComp menuId={id} />
            </Suspense>
            <LinksComp
              links={links}
              menuId={id}
              highLightObjectId={props.highLightObjectId}
              highLightObjectType={props.highLightObjectType}
              additionalParams={props.additionalParams}
              t={t}
            />
            <div
              className={`${id}-menu-scroll-bar verticalScroll`}
            >
              {props.show_collapse_all ? (
                <ExpandAllLink
                  id={id}
                  status={props.collapse_all}
                  openCloseAllExpand={openCloseAllExpand}
                />
              ) : (
                ''
              )}
              <UlMenuComp
                key={`main_${id}`}
                menus={menus}
                highLightObjectId={props.highLightObjectId}
                highLightObjectType={props.highLightObjectType}
                additionalParams={props.additionalParams}
                menuId={id}
                id={id}
                dropId={id}
                menu_sorting={menu_sorting}
                expaned_all={props.collapse_all}
                clickCollapse={clickCollapse}
                actions={actions}
              />
            </div>
            <ButtonGroupComp menuId={id} buttons={buttons} />
          </div>
        </div>
      ) : (
        <ThemeProvider>
          <Button
            aria-expanded="false"
            aria-label="toggle-sidebar"
            className="globalLeftKeepOpen"
            id="globalLeftKeepOpen"
            onClick={e => clickKeepOpen(e, 'true')}
          >
            <img aria-hidden="true" src={`${wbConfig.baseUrl}/images/icons/main_menu/add/ic-show.png`}
            title="show side panel" width="24px"/>
          </Button>
        </ThemeProvider>
      )}
    </div>
  );
}

const ExpandAllLink = props => {
  const { id, status } = props;
  const { t } = useTranslation();
  let icon = '/images/icons/main_menu/grey.png';
  let iconClass = 'all-open-icon';
  let colName = t('EXPAND ALL');
  if (status == '1') {
    icon = '/images/icons/main_menu/grey@3x.png';
    iconClass = 'all-closed-icon';
    colName = t('COLLAPSE ALL');
  }
  const _status = status == '1' ? 0 : 1;
  return (
    <div className="all-open-close-section">
      <ThemeProvider>
      <Button
        style={{width: '88%', margin: '5px 0px 0px 30px', padding: 0}}
        data-status={_status}
        aria-expanded={ _status == "0" ? true : false}
        aria-controls="wb-primary-menu"
        aria-labelledby="expColAll"
        onClick={e => props.openCloseAllExpand(e, _status)}>
          <div className={iconClass}>
            <span className={`wmenu-icon ${_status == 0? 'expend' : ''}`}/>
            <span className="expColAll" id="expColAll" style={{paddingLeft:'10px'}}>{colName}</span>
          </div>
        </Button>
      </ThemeProvider>
      <div className="clear" />
    </div>
  );
};

const GroupedLinksComp = props => {
  const {
    group = '',
    links = [],
    menuId,
    highLightObjectId = '',
    highLightObjectType = '',
    additionalParams = ''
  } = props;
  if (!links.length) return null;

  const ulEl = (
    <ul
      className="wb-primary-menu"
      style={{ paddingBottom: '5px', display: 'block' }}
    >
      {links.map((item, index) => (
        <LinkComp
          key={`link_${menuId}_${index}`}
          item={item}
          p="1"
          menuId={menuId}
          highLightObjectId={highLightObjectId}
          highLightObjectType={highLightObjectType}
          additionalParams={additionalParams}
        />
      ))}
    </ul>
  )

  if (!group) {
    return ulEl;
  }

  return (
    <div className="wb-primary-menu-group">
      <h3 className="wb-primary-menu-group-name">{group}</h3>
      {ulEl}
    </div>
  );
};

const LinksComp = props => {
  const {
    links = [],
    menuId,
    highLightObjectId = '',
    highLightObjectType = '',
    additionalParams = ''
  } = props;
  if (!links.length) return null;

  // group links by data-group attribute
  const groupedLinks = links.reduce((acc, link) => {
    const group = link.attributes['data-group'] || '';
    if (!acc[group]) {
      acc[group] = [];
    }
    acc[group].push(link);
    return acc;
  }, {});

  return (
    <div className="wb-primary-menu-group-container">
      {Object.keys(groupedLinks).map((group, index) => (
        <GroupedLinksComp
          key={`group_${menuId}_${index}`}
          group={group}
          links={groupedLinks[group]}
          menuId={menuId}
          highLightObjectId={highLightObjectId}
          highLightObjectType={highLightObjectType}
          additionalParams={additionalParams}
        />
      ))}
    </div>
  );
};

const UlMenuComp = props => {
  const {
    menus = [],
    p = 1,
    subLevelExpand = false,
    expaned_all = 0,
    menu_sorting = false,
    sorting = false,
    highLightObjectId = '',
    highLightObjectType = '',
    additionalParams = '',
    actions
  } = props;
  let pClass = 'secondary';
  const ulStyle = {};
  let liClass = '';
  let ulClass = '';
  const ulAttr = {};
  let pIndex = 0;
  let sIndex = 0;
  if (p == '1') {
    pClass = 'primary';
    ulStyle.paddingBottom = '5px';
    ulStyle.display = 'block';
    liClass = ' menurow wb-primary-box ';
  } else {
    ulStyle.display = subLevelExpand ? 'block' : 'none';
  }
  const totalItems = Array.isArray(menus) ? menus.length : 0;
  if (menu_sorting && totalItems < 100) {
    ulClass = ' leftmenu-primary-menu-sorting ';
    ulAttr['data-id'] = 'streams';
  }
  useEffect(() => {
    if (sorting) {
      $(".leftmenu-sorting-item.leftmenu-" + props.id).sortable({
          axis: "y",
          items: ".wb-secondary-menu-li",
          tolerance: "pointer",
          connectWith: "#leftmenu_navigation",
          cancel: ":input,button,[contenteditable]",
          start(event, ui) {
            console.log('start index', ui.item.index());
            sIndex = ui.item.index();
          },
          update(event, ui) {
            console.log('indx', ui.item.index(), sIndex);
            let type = $(this)
              .closest(".leftmenu-sorting-item")
              .attr("data-id");
            let ids = $(this)
              .closest(".leftmenu-sorting-item")
              .sortable("toArray", { attribute: "data-id" });
            if (props.menuId == "board") {
              if (type == "board_favorites") {
                const idTypes = $(this)
                  .closest(".leftmenu-sorting-item")
                  .sortable("toArray", { attribute: "data-type" });
                ids = ids.map((v, i) => `${idTypes[i]}_${v}`);
              } else if (type == "-1") {
                type = "private_streams";
              } else if (type == "-2") {
                type = "sharedWorkstreams";
              } else if (type == "-3") {
                type = "archived";
              } else {
                type = `streams_${type}`;
              }
            }
            if (ids.length) {
              actions.sortingLeftMenu(props.menuId, {
                type,
                ids,
                sourceIndex: sIndex,
                destinationIndex: ui.item.index()
              });
            }
          }
        });
    }
    if (menu_sorting) {
      $(".leftmenu-primary-menu-sorting").sortable({
        axis: "y",
        items: ".wb-primary-menu-li-sortable",
        tolerance: "pointer",
        connectWith: "#leftmenu_navigation",
        cancel: ":input,button,[contenteditable]",
        start(event, ui) {
          pIndex = ui.item.index();
        },
        update(event, ui) {
          const type = $(this)
            .closest(".leftmenu-primary-menu-sorting")
            .attr("data-id");
          const ids = $(this)
            .closest(".leftmenu-primary-menu-sorting")
            .sortable("toArray", { attribute: "data-id" });
            if (ids.length) {
              actions.sortingLeftMenu(props.menuId, {
                type,
                ids,
                sourceIndex: pIndex,
                destinationIndex: ui.item.index()
              });
            }
        }
      });
    }
  },
  [props.menuId]);

  return (
    <ul
      className={`wb-${pClass}-menu ${ulClass}`}
      style={ulStyle}
      id={ pClass == "primary" ? `wb-${pClass}-menu` : `wb-${pClass}-menu-${props.id}`}
      {...ulAttr}
      >
    {menus.map((menu, index) =>
     p == '1' ? (
       <li
            key={`pmenu_${menu.id}`}
            className={`wb-${pClass}-menu-li ${liClass}${
              (menu.sorting && menu.menus.length < 100) ? " leftmenu-sorting-item leftmenu-" + menu.id : ""
            }${menu.id > -3 ? " wb-primary-menu-li-sortable " : ""}`}
            {...menu.attributes}
            data-id={menu.id}
            data-testid={`wb-${pClass}-menu-list-item`}
          >
            <div className="">
              <div
                className="wb-primary-menu-li-row"
                onClick={e => props.clickCollapse(e, menu.id, menu.expand)}
              >
                <div className="wb-primary-menu-li-col2">
                  <span
                    className={`wmenu-icon ${menu.expand ? ' expend ' : ''}`}
                    role="button"
                    aria-labelledby={menu.id}
                    tabIndex="0"
                    aria-expanded={menu.expand ? true : false}
                    aria-controls={`wb-secondary-menu-${menu.id}`}
                    onKeyDown={(e) => { if(e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      props.clickCollapse(e, menu.id, menu.expand);}
                    }}
                  />
                </div>
                <div className="wb-primary-menu-li-col1" id={menu.id}>{menu.name}</div>
              </div>
              {Array.isArray(menu.menus) && menu.menus.length ? (
                <UlMenuComp
                  key={`pmenu_${p}_${menu.id}`}
                  menuId={props.menuId}
                  id={menu.id}
                  dropId={`${props.menuId}_${menu.id}`}
                  highLightObjectId={highLightObjectId}
                  highLightObjectType={highLightObjectType}
                  menus={menu.menus}
                  p="2"
                  subLevelExpand={menu.expand}
                  additionalParams={additionalParams}
                  actions={actions}
                  sorting={menu.sorting && menu.menus.length < 100}
                />
              ) : (
                ''
              )}
            </div>
          </li>
    ) : (
          <LinkComp
            key={`m_${menu.obj_type}_${menu.obj_id || menu.id}`}
            item={menu}
            p={p}
            menuId={props.menuId}
            highLightObjectId={highLightObjectId}
            highLightObjectType={highLightObjectType}
            additionalParams={additionalParams}
          />
    )
    )}
  </ul>
  )
}

const LinkComp = (props) => {
  const {
    item,
    p = 1,
    menuId,
    highLightObjectId = '',
    highLightObjectType = '',
    additionalParams = ''
  } = props;
  const { t, i18n } = useTranslation();
  const itemStyle = item.style ? item.style : {};
  let itemAttr = {};
  const menuIndex = false;
  if (item.menu_index) {
    itemAttr['data-menu-index'] = item.menu_index;
  }
  let _objectId = '';
  let _objectType = '';
  if (item.id) {
    itemAttr['data-id'] = item.id;
    if (menuId == 'board') {
      _objectType = item.obj_type || '';
    }
    _objectId = item.id;
  }
  // overrides id with favorites obj_id
  let extraText = '';
  if (item.obj_id) {
    itemAttr['data-id'] = item.obj_id;
    _objectType = item.obj_type;
    _objectId = item.obj_id;
    if (item.obj_type == 'user_goal' || item.obj_type == 'team_goal') {
      extraText = `'s ${t('objectives')}`;
    }
    if( item.obj_type  == 'personKeyResult'){
      itemAttr['data-id'] = item.obj_encrypt_id;
    }
    itemAttr['data-type'] = item.obj_type;
    if (item.obj_type == 'meeting' && item.meetingUserId) {
      itemAttr['data-userid'] = item.meetingUserId;
      itemAttr['data-mtype'] = item.meetingType;
    }
  }

  // A11y for each added item
  // itemAttr['role'] = 'link';
  // itemAttr['tabIndex'] = '0';

  if (item.attributes) {
    itemAttr = Object.assign({}, itemAttr, item.attributes);
  }
  let pClass = 'secondary';
  let liClass = '';
  if (p == '1') {
    pClass = 'primary';
    liClass = ' menurow ';
  }
  if (menuId) {
    liClass += ` wb-${pClass}-${menuId}-menu-li `;
  }
  if (item.class) {
    liClass = `${liClass} ${item.class}`;
  }
  if (
    highLightObjectId &&
    highLightObjectId == _objectId &&
    (menuId != 'board' ||
      (menuId == 'board' && highLightObjectType == _objectType))
  ) {
    liClass += ' active ';
    itemAttr['aria-current'] = 'page';
  }
  const showCountDiv = typeof item.count !== 'undefined';
  const imageUrl = wbConfig.imageCdnUrl;
  let iconPath = '';
  if (menuId == 'rbr') {
    const rbrType = typeof item.type !== 'undefined' ? item.type : '';
    item.imagePath = '';
    if (rbrType == RbrConst.RBR_TYPE_ORG) {
      iconPath = 'org_rbr.png';
    } else if (
      rbrType == RbrConst.RBR_TYPE_PRIVATE ||
      rbrType == RbrConst.RBR_TYPE_PERSONAL
    ) {
      iconPath = 'grey_lock@3x.png';
    }
    if (iconPath) {
      item.imagePath = `${imageUrl}/images/shared_RBR/${iconPath}`;
    }
  } else if (menuId == 'board') {
    item.imagePath = '';
    const sharedBoardType =
      typeof item.share_type !== 'undefined' ? item.share_type : '';
    if (sharedBoardType == BoardConst.BOARD_TYPE_ORG) {
      iconPath = 'org_rbr.png';
    } else if (
      sharedBoardType &&
      sharedBoardType == BoardConst.BOARD_TYPE_PRIVATE
    ) {
      iconPath = 'grey_lock@3x.png';
    }
    if (iconPath) {
      item.imagePath = `${imageUrl}/images/shared_RBR/${iconPath}`;
    }
  } else if (menuId == 'meeting') {
    // higlight meeting leftmenu if meeting details page is opened.
    // console.log('additionalParams', additionalParams);
    if (additionalParams && typeof additionalParams.id !== 'undefined') {
      const meetingType = additionalParams.type;
      const meetingStatus = additionalParams.status;
      let highId = '';
      if (meetingStatus != '1') {
        highId = 'meeting_pastmeetings';
      } else {
        highId = meetingType == '1' ? 'meeting_1on1s' : 'meeting_meetings';
      }
      if (highId && highId == item.id) {
        liClass += ' active ';
        itemAttr['aria-current'] = 'page';
      }
    }
  } else if (menuId == 'goal') {
    // don't show Due for update now link if count is zero.
    if (item.id == 'goal_dueforupdatenow' && !item.count) {
      return null;
    }
    if (
      highLightObjectId &&
      item.id == 'goal_heatmap' &&
      (highLightObjectType == 'user_goal' || highLightObjectType == 'team_goal')
    ) {
      liClass += ' active ';
      itemAttr['aria-current'] = 'page';
    }
  }

  const anchorProps = {
    href: '#',
    onClick: (e) => { e.preventDefault() },
  }

  if (itemAttr['data-link'] === 'true') {
    Object.keys(itemAttr)
      .filter((key) => key.startsWith('data-link-'))
      .forEach((key) => {
        const name = key.replace('data-link-', '')
        anchorProps[name] = itemAttr[key]
      })

    Object.assign(anchorProps, {
      onClick: null,
    })
  }
  const components = {
    NotesOutlinedIcon: NotesOutlinedIcon,
  }

  let DynamicComponent;
  if (item.reactComponent) {
    if (!components[item.reactComponent]) {
      console.error(`Component ${item.reactComponent} not found`);
    } else {
      DynamicComponent = components[item.reactComponent];
    }
  }

  return (
    <li className={`wb-${pClass}-menu-li ${liClass}`} {...itemAttr}>
      <div className="second-col" data-testid="Second-col" style={{ itemStyle }}>

      <a {...anchorProps} >
        <span
          className="nav-menu-link"
        >
          <span>{DynamicComponent && <DynamicComponent />}{item.name + extraText}</span>
          {item.status == 0 && item.teamName ? (
            <span> {`: ${item.teamName}`} </span>
          ) : (
            ''
          )}
        </span>
        {item.imagePath ? (
          <span style={{ width: '10%', verticalAlign: 'top' }}>
            <img
              src={item.imagePath}
              width="10"
              height="10"
              style={{ marginTop: '3px', verticalAlign: 'top' }}
            />
          </span>
        ) : (
          ''
        )}
         </a>
      </div>

      {showCountDiv ? (
        <div className="first-col">
          <span className="mywork-numbers">{item.count ? item.count : 0}</span>
        </div>
      ) : (
        ''
      )}
    </li>
  );
};

const ButtonGroupComp = props => {
  const { buttons = [] } = props;
  if (!buttons.length) return null;
  return (
    <div className="leftmenu-buttons-wrapper">
      {buttons.map(button => (
        <ButtonComp key={Math.random() * 1000} button={button} />
      ))}
    </div>
  );
};

const ButtonComp = ({ button } = props) => {
  const buttonClass = button.class ? button.class : '';
  const attributes = button.attributes ? button.attributes : {};
  const buttonAttrs = button.buttonAttrs ? button.buttonAttrs : {};
  const buttonMargin = button.uniqClass ? button.uniqClass : '';

  return (
    <div
      className={`button-box ${buttonClass}`}
      {...attributes}
      onClick={() => userService.trackNavigation({ location: 'left', item: button.title })}
    >
      <div
        className={`inlineBlock cursorPointer ${buttonMargin}`}
        id={button.id}
        { ...buttonAttrs }
      >
        <img
          aria-hidden="true"
          width="20px"
          src={wbConfig.imageCdnUrl + button.iconPath}
          style={{ marginRight: '5px' }}
        />
        <span className="add-title-menu">{button.title}</span>
      </div>
    </div>
  );
};

// let LeftMenuCompM = connect(function ms(state){return state;})(LeftMenuComp);

const LeftmenuActiveComp = (props) => {

  const { leftmenuData, actions, t } = props;
  const { activeMenuId } = leftmenuData;
  const _menus = leftmenuData.topmenus;

  useEffect(() => {
    // active leftmenu favorites
    setTimeout(() => updateTopMenuFavorites(activeMenuId), 300);
  }, [props]);

  // if left menu is closed, we need to redraw the heatmap
  // to correct it's width
  useEffect(() => {
    if (leftmenuData[activeMenuId] && leftmenuData[activeMenuId].keep_open === 'false') {
      document.getElementById('heatMapViz') !== null &&
      typeof drawHeatmapChart === 'function' &&
      drawHeatmapChart();
    }
  }, []);

  const updateTopMenuFavorites = (type) => {
    if (typeof leftmenuData[type] !== 'undefined') {
      const { menus } = leftmenuData[type];
      if (typeof leftMenuModel !== 'undefined') {
        leftMenuModel.updateTopmenuFavorites(
          type,
          menus
        );
      }
    }
  }

  if (
    typeof leftmenuData[activeMenuId] !== 'undefined' &&
    activeMenuId &&
    leftmenuData[activeMenuId]
  ) {
    return (
      <Suspense fallback={null}>
        <LeftMenuComp
          id={activeMenuId}
          {...leftmenuData[activeMenuId]}
          actions={actions}
          t={t}
        />
      </Suspense>
    );
  }

  setLeftMenuWidth(0);
  cssUpdates(0);
  return null;
}

// export default hot(LeftmenuActiveComp);
const enhance = compose(withTranslation(), hot);
export default enhance(LeftmenuActiveComp);

const setLeftMenuWidth = (width) => {
  $('#contentTd').css({
    "min-width": width,
    "width": width
  });
};

const cssUpdates = (width) => {
  // Update left menu width CSS var
  document.documentElement.style.setProperty('--leftMenuWidth', width + 'px');

  // Revert OKR tree viz styles
  if (!(document.querySelector('.cascade-visualization-svg') ||
        document.querySelector('.goalalign-visualization-svg'))) {

    // Standard footer behavior
    let elem = document.querySelector('div#footer');
    if (elem) {
      elem.classList.remove('fixedbottom-footer');
    }
  }

  // Revert admin tools overflow style changes
  $('.admin-overflow-visible').removeClass('admin-overflow-visible');
};

const openCreateBoardPopUp = function(createBoard, orgConfig) {
  const mountId =  document.getElementById('createBoard');
  if (mountId) {
    createRoot(document.getElementById('createBoard')).render(
      <Suspense fallback={null}>
        <CreateBoardPopup orgConfig={orgConfig} />
      </Suspense>,
    );
    // Initialize the dialog box with set height and width
    $(`#${createBoard}`).dialog({ height: 575, width: 900 });
    $(`#${createBoard}`).dialog('open');
  }
}

window.openCreateBoardPopUp = openCreateBoardPopUp;

let createMeetingRoot;
const closeCreateMeetingModal = () => {
  const createMeetingElement = document.getElementById("createMeeting");

  if (createMeetingElement) {
    createMeetingRoot?.unmount();
  }
}
window.closeCreateMeetingModal = closeCreateMeetingModal;

const triggerCreateMeetingEvent = function(type) {
  const meetingsApp = document.getElementById('meetings-app');

  if (meetingsApp) {
    const createMeetingEvent = new CustomEvent('createMeeting', { detail: type });
    meetingsApp.dispatchEvent(createMeetingEvent);
    return true;
  }

  return false;
}

const openCreateMeetingModal = function() {
  if (triggerCreateMeetingEvent('group')) {
    return;
  }
  const createMeetingElement = document.getElementById('createMeeting');
  if (createMeetingElement) {
    createMeetingRoot = createRoot(createMeetingElement);
    createMeetingRoot.render(
      <Router>
        <Suspense fallback={null}>
          <CreateMeetingModalStandalone />
        </Suspense>
      </Router>
    );
  }
}
window.openCreateMeetingModal = openCreateMeetingModal;


const openCreate1on1Modal = function(props) {
  if (triggerCreateMeetingEvent('1on1')) {
    return;
  }
  const passProps = props && Object.keys(props).length ? props : {};
  const createMeetingElement = document.getElementById('createMeeting');
  if (createMeetingElement) {
    createMeetingRoot = createRoot(createMeetingElement);
    createMeetingRoot.render(
      <Router>
        <Suspense fallback={null}>
          <Create1on1ModalStandalone {...passProps} />
        </Suspense>
      </Router>,
      createMeetingElement
    );
  }
}
window.openCreate1on1Modal = openCreate1on1Modal;

const meetNow = () => {
  // if called while the meeting app is open we will
  // trigger a createMeeting event, otherwise the menu url
  // will create a meeting and the triggerXX() call won't
  // do anything
  triggerCreateMeetingEvent('meetNow');
}
window.meetNow = meetNow;

let krCopyModalRoot;
const openKrCopyModal = (metric) => {
  const krCopyModalEl = document.getElementById('openKrCopyModal');

  if (krCopyModalEl) {
    krCopyModalRoot = createRoot(krCopyModalEl);
    krCopyModalRoot.render(
      <Router>
        <Suspense fallback={null}>
          <CreateCopyKrModal
            isOpen
            key="goal-search"
            metric={metric}
          />
        </Suspense>
      </Router>
    );
  }
}

const closeKrCopyModal = () => {
  const openKrCopyModalElement = document.getElementById('openKrCopyModal');

  if (openKrCopyModalElement) {
    krCopyModalRoot?.unmount();
  }
}
window.closeKrCopyModal = closeKrCopyModal;
window.openKrCopyModal = openKrCopyModal;
